class AnnouncementBarSlider extends HTMLElement {
	constructor() {
		super();
		this.swiperInstance = null;
		this.swiperEl = null;
		this.loadListenerAttached = false;
	}

	connectedCallback() {
		this.swiperEl = this.querySelector('.swiper-announcement-bar');
		if (!this.swiperEl) return;
        this.initSwiper();
	}

	initSwiper() {
		if (typeof Swiper === 'undefined') {
			if (!this.loadListenerAttached) {
				window.addEventListener('load', this.handleWindowLoad, { once: true });
				this.loadListenerAttached = true;
			}
			return;
		}
		const changeSlidesSpeed = this.getAttribute('data-change-slides-speed');
		const delay = changeSlidesSpeed * 1000;

		const config = {
			slidesPerView: 1,
			loop: true,
            autoplay: {
                delay: delay,
                disableOnInteraction: false,
            },
            breakpoints: {
                990: {
                    slidesPerView: 4,
                }
            }
		};

		this.swiperInstance = new Swiper(this.swiperEl, config);
	}

    handleWindowLoad() {
		this.loadListenerAttached = false;
	}
}

if (!customElements.get('announcement-bar-slider')) {
	customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}